var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoJornal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03223 86.735L30.7974 59.9699L48.6408 77.8133L84.3277 42.1264",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M84.3274 55.509V42.1264H70.9448",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1886 16.5472C10.8972 16.3941 10.5492 16.3941 10.2579 16.5472L6.02978 18.7701C5.29615 19.1558 4.43872 18.5328 4.57883 17.7159L5.38632 13.0078C5.44196 12.6834 5.33441 12.3524 5.09873 12.1227L1.67811 8.78841C1.0846 8.20988 1.4121 7.2019 2.23233 7.08272L6.9595 6.39582C7.28521 6.34849 7.56677 6.14392 7.71244 5.84878L9.82649 1.56523C10.1933 0.821987 11.2532 0.821985 11.62 1.56523L13.734 5.84878C13.8797 6.14392 14.1612 6.34849 14.487 6.39582L19.2141 7.08272C20.0344 7.2019 20.3619 8.20987 19.7683 8.78841L16.3477 12.1227C16.112 12.3524 16.0045 12.6834 16.0601 13.0078L16.8676 17.7159C17.0077 18.5328 16.1503 19.1558 15.4167 18.7701L11.1886 16.5472Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6446 16.5472C44.3533 16.3941 44.0053 16.3941 43.7139 16.5472L39.4858 18.7701C38.7522 19.1558 37.8948 18.5328 38.0349 17.7159L38.8424 13.0078C38.898 12.6834 38.7905 12.3524 38.5548 12.1227L35.1342 8.78841C34.5407 8.20988 34.8682 7.2019 35.6884 7.08272L40.4156 6.39582C40.7413 6.34849 41.0228 6.14392 41.1685 5.84878L43.2825 1.56523C43.6494 0.821987 44.7092 0.821985 45.076 1.56523L47.1901 5.84878C47.3357 6.14392 47.6173 6.34849 47.943 6.39582L52.6702 7.08272C53.4904 7.2019 53.8179 8.20987 53.2244 8.78841L49.8038 12.1227C49.5681 12.3524 49.4606 12.6834 49.5162 13.0078L50.3237 17.7159C50.4638 18.5328 49.6064 19.1558 48.8727 18.7701L44.6446 16.5472Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.1017 16.5472C77.8103 16.3941 77.4623 16.3941 77.171 16.5472L72.9429 18.7701C72.2092 19.1558 71.3518 18.5328 71.4919 17.7159L72.2994 13.0078C72.355 12.6834 72.2475 12.3524 72.0118 12.1227L68.5912 8.78841C67.9977 8.20988 68.3252 7.2019 69.1454 7.08272L73.8726 6.39582C74.1983 6.34849 74.4799 6.14392 74.6255 5.84878L76.7396 1.56523C77.1064 0.821987 78.1662 0.821985 78.5331 1.56523L80.6471 5.84878C80.7928 6.14392 81.0743 6.34849 81.4 6.39582L86.1272 7.08272C86.9474 7.2019 87.2749 8.20987 86.6814 8.78841L83.2608 12.1227C83.0251 12.3524 82.9176 12.6834 82.9732 13.0078L83.7807 17.7159C83.9208 18.5328 83.0634 19.1558 82.3298 18.7701L78.1017 16.5472Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoJornal);
export default __webpack_public_path__ + "static/media/ico-jornal.580f7d29504a07973b183c23acc61d56.svg";
export { ForwardRef as ReactComponent };